import config from 'constants/config'

/**
 * `flagged`: svc-order wants this member shown the public rate.
 * `clear`: not flagged. svc-order also answers this when its own checks fail, so it can't tell us why.
 * `failed`: no answer (timeout, network, 4xx/5xx, or the endpoint isn't deployed yet).
 */
export type HotelSightOutcome = 'flagged' | 'clear' | 'failed'

export function isHotelSightEnabled(): boolean {
  return config.GHA_HOTEL_SIGHT_ENABLED
}
